import api from '@/api';

export default {
    namespaced: true,

    state: {
        accounts: [],
    },

    actions: {

        async getShortLinks(context, obj) {
            let url = `/admin/short_links?page=${obj.page}`;
            const response = await api.request('get', url);
            return response.data;

        },

        async addShortLink(context, item) {
            let url = `/admin/short_links`;
            const response = await api.request('post', url, item);
            return response.data;
        },
        async editShortLink(context, item) {
            let url = `/admin/short_links/${item.id}`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async deleteShortLink(context, item) {
            let url = `/admin/short_links/${item.id}`;
            const response = await api.request('delete', url, item);
            return response.data;
        },
    },
    mutations: {}
};
